/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PipesModule} from '../../../shared/pipes/pipes.module';
import {PartNumberChangesAdditionalSpoNumberComponent} from './part-number-changes-additional-spo-number.component';
import {PartNumberChangesAdditionalInputModule} from '../../shared/part-number-changes-additional-input/part-number-changes-additional-input.module';
import {InputModule} from '../../../shared/input/input.module';

@NgModule({
    declarations: [PartNumberChangesAdditionalSpoNumberComponent],
    imports: [
        CommonModule,
        PipesModule,
        PartNumberChangesAdditionalInputModule,
        InputModule
    ],
    exports: [
        PartNumberChangesAdditionalSpoNumberComponent
    ]
})
export class PartNumberChangesAdditionalSpoNumberModule {
}
